import styled, {createGlobalStyle} from "styled-components"
import {Link} from "gatsby";
import {ErrorMessage, Field} from "formik";

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${props => props.theme.background()};
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: 16px;
    
    @media (max-width: 768px) {
      display: block;
    }
  }

  .ril__toolbar {
    background-color: transparent!important;
  }
  
  #___gatsby {
    width: 100%;
  }
`;

export const FullWidthContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  background-color: ${props => props.theme.background()};
`;

export const MaxWidthContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
`;

export const Heading = styled.div`
  padding: ${props => props.theme.bleed}px 0;
  font-weight: ${props => props.theme.bold};
  color: ${props => props.theme.colors.neutrals._900};
  font-family: "Barlow", sans-serif;
`;

export const Heading1 = styled(Heading)`
  font-family: Playfair Display, sans-serif;
  font-style: italic;
  font-size: 5.5em;

  @media (max-width: 768px) {
    font-size: 2em;
  }
`;

export const Heading2 = styled(Heading)`
  font-size: 2em;
  
  @media (max-width: 768px) {
    font-size: 2em;
  }
`;

export const Heading3 = styled(Heading)`
  font-size: 1.5em;
`;

export const Heading4 = styled(Heading)`
  font-size: 1.25em;
  line-height: 2em;
`;

export const Paragraph = styled.p`
  font-size: 1em;
  line-height: 1.5em;
  padding: ${props => props.theme.bleed}px 0;
`;

export const Info = styled.span`
  font-size: 0.75em;
`;

export const HashTag = styled(Heading3)`
  color: ${props => props.theme.text};
  padding: 0;
`;

export const QuoteParagraph = styled(Paragraph)`
  font-style: italic;
`;

export const Strike = styled.span`
  text-decoration: line-through;
`;

export const MiniParagraph = styled(Paragraph)`
  padding: 2px 0;
`;

export const UnorderedList = styled.ul`
  padding: 0 0 15px 0;
  list-style: outside;
`;
export const ListItem = styled.li`
  padding: 10px 0;
  list-style-position: outside;
  margin-left: 2em;
`;

export const InternalLink = styled(Link)`
  text-decoration: none;
  color: ${props => props.theme.colors.primary._500};
`;

export const ExtLink = styled.a`
  text-decoration: none;
  color: ${props => props.theme.colors.primary._500};
  font-weight: 700;
  
  :visited {
    color: ${props => props.theme.colors.primary._500};
  }
`;

export const Highlight = styled.span`
  color: ${props => props.theme.colors.primary._600};
`;

export const Bold = styled.span`
  font-weight: 700;
`;

export const Form = styled.form`
  display: flex;
`;

export const Label = styled.label`
  display: inline-block;
  width: 100%;
  border: ${props => props.theme.colors.neutrals._500} 1px solid;
`;

export const TextInput = styled.input`
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #F2F2F3;
  display: inline-block;
  width: 100%;
  height: 100%;
`;

export const Button = styled.button`
  cursor: pointer;
  display: inline-block;
  padding: 10px 15px;
  text-decoration: none;
  text-align: center;
`;

export const CtaButton = styled(Button)`
  background-color: ${props => props.theme.colors.primary._400};
  color: ${props => props.theme.colors.neutrals._000};
  
  :visited {
    background-color: ${props => props.theme.colors.primary._400};
    color: ${props => props.theme.colors.neutrals._000};
  }
`;

export const CtaHighContrastButton = styled(CtaButton)`
  background-color: ${props => props.theme.colors.neutrals._000};
  color: ${props => props.theme.colors.accent2._300};
  
  :visited {
    background-color: ${props => props.theme.colors.neutrals._000};
    color: ${props => props.theme.colors.accent2._300};
  }
`;

export const YearsColorCtaButton = styled(Button)`
  background-color: ${props => props.theme.colors.secondary.base};
  color: ${props => props.theme.colors.neutrals._000};
`;

export const WireframeButton = styled(Button)`
  background-color: transparent;
  border: 1px solid ${props => props.theme.colors.neutrals.textDefault};
  color: ${props => props.theme.colors.neutrals.textDefault};
  
  :visited {
    color: ${props => props.theme.colors.neutrals.textDefault};
  }
  
  :hover {
    background-color: ${props => props.theme.colors.neutrals.textDefault};
    color: ${props => props.theme.colors.neutrals._000};
  }
`;

export const CtaWireframeButton = styled(WireframeButton)`
  border: 2px solid ${props => props.theme.colors.secondary._600};
  color: ${props => props.theme.colors.secondary._700};
  
  :visited {
    color: ${props => props.theme.colors.secondary._700};
  }
  
  :hover {
    background-color: ${props => props.theme.colors.secondary._600};
    color: ${props => props.theme.colors.neutrals._000};
  }
`;

export const CtaWireframeHighContrastButton = styled(CtaWireframeButton)`
  color: ${props => props.theme.colors.neutrals._000};
  border-color: ${props => props.theme.colors.neutrals._000};

  :visited {
    color: ${props => props.theme.colors.neutrals._000};
  }
  
  :hover {
    background-color: ${props => props.theme.colors.neutrals._000};
    color: ${props => props.theme.colors.accent2._300};
    border-color: ${props => props.theme.colors.neutrals._000};
  }
`

export const FormField = styled(Field)`
  padding: 15px 20px;
  
  &[type='text'] {
    border: 1px solid #C8CDD0;
  }
  
  ::placeholder {
    color: #C8CDD0;
    font-style: normal;
  }
`;

export const Capital = styled.span`
  text-transform: capitalize;
`;

export const FormErrorMessage = styled(ErrorMessage)``;